<template>
  <el-dialog
    title="更新产品图文信息"
    :visible.sync="visible"
    width="800px"
    append-to-body=""
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-tabs
      v-if="visible"
      v-model="activeTab">
      <el-tab-pane
        label="展示窗口1"
        name="2">
        <tab-item-form
          ref="tabItem2"
          :vacIds="vacIds"
          fieldCode="tab2" />
      </el-tab-pane>
      <el-tab-pane
        label="展示窗口2"
        name="3">
        <tab-item-form
          ref="tabItem3"
          :vacIds="vacIds"
          fieldCode="tab3" />
      </el-tab-pane>
    </el-tabs>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">关 闭</el-button>
      <el-button
        :loading="loading"
        type="primary"
        @click="updatevacconfig">更 新</el-button>
    </template>
  </el-dialog>
</template>
<script>
import TabItemForm from './tab-item-form.vue'
export default {
  name: 'ProductVacConfigModal',
  components: { TabItemForm },
  data() {
    return {
      loading: false,
      visible: false,
      activeTab: '2',
      vacIds: [],
      config: { productId: null, productName: '' }
    }
  },
  methods: {
    handleClosed() {
      this.vacIds = []
      this.config = { ...this.config, ...this.$options.data().config }
    },
    getTabInfo(o) {
      o.fieldValue = JSON.parse(o.fieldValue)
      return { ...o, fieldList: o.fieldValue.multiMedias.map(item => ({ id: item.id, name: item.name, mediaType: item.mediaType, url: item.content })), fieldValue: null }
    },
    getvacconfigs() {
      this.$store.dispatch('vas/getvacconfigs', {
        payload: { ...this.config },
        success: (res) => {
          const { result, message, records } = res.data
          this.loading = false
          if ([0].includes(result)) {
            this.vacIds = records.map(item => item.vacId)
            records.forEach(item => {
              if (item.vacId === 3) {
                (item.vacFields || []).forEach(o => {
                  if (o.fieldCode === 'tab2') {
                    this.$refs.tabItem2.init(this.getTabInfo(o))
                  }
                  if (o.fieldCode === 'tab3') {
                    this.$refs.tabItem3.init(this.getTabInfo(o))
                  }
                })
              }
            })
          } else {
            this.$message.error(message)
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updatevacconfig() {
      const tab2Form = this.$refs.tabItem2.validate('2')
      const tab3Form = this.$refs.tabItem3.validate('3')
      const validate = [tab2Form, tab3Form]
      Promise.all(validate)
        .then(([tab2, tab3]) => {
          const post = { ...this.config, vacConfigs: [] }
          this.vacIds.forEach(item => {
            const arrayItem = { vacId: item, vacFields: [] }
            if (item === 3) {
              arrayItem.vacFields.push(
                {
                  'fieldCode': 'tab2',
                  'fieldName': tab2.fieldName,
                  'fieldValue': JSON.stringify({ 'multiMedias': tab2.fieldList.map(item => ({ id: item.id, name: item.name, mediaType: item.mediaType, content: item.url })) }),
                  'h5Display': tab2.h5Display
                },
                {
                  'fieldCode': 'tab3',
                  'fieldName': tab3.fieldName,
                  'fieldValue': JSON.stringify({ 'multiMedias': tab3.fieldList.map(item => ({ id: item.id, name: item.name, mediaType: item.mediaType, content: item.url })) }),
                  'h5Display': tab3.h5Display
                }
              )
            }
            post.vacConfigs.push(arrayItem)
          })
          console.log(post)
          this.loading = true
          this.$store.dispatch('vas/updatevacconfig', {
            payload: post,
            success: () => {
              this.loading = false
              this.$message.success('更新成功')
              // this.getvacconfigs()
              this.visible = false
            },
            fail: () => {
              this.loading = false
            }
          })
        })
        .catch(err => {
          this.loading = false
          this.activeTab = err.tab
        })
    },
    init(options = {}) {
      this.config = { ...this.config, ...options }
      this.visible = true
      this.getvacconfigs()
    }
  }
}
</script>
